module.exports = __webpack_public_path__ + "static/media/hotelPageGroomingIcon.60881594.png";